import { logout } from "../utils/authUtils";
import { ErrorToast } from "../widgets/AppToast";
import instance from "./axiosInterceptors";

export const post = async (url, formData) => {
  // const login_token = localStorage.getItem("login_token");
  // const refresh_token = localStorage.getItem("refresh_token");
  // formData.append("login_token", login_token);
  // formData.append("refresh_token", refresh_token);
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  };
  return instance
    .post(url, formData, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      if (error.response && error.response.status === 401) {
        console.error("Unauthorized, please login again.");
        const errorMessage = "Unauthorized access. Please Login again.";
        ErrorToast("Login Error ", errorMessage);
        // setTimeout(() => {
        //   logout();
        // }, 5000);
      }
      return error;
    });
};

export const get = async (url) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .get(url, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};

export const put = async (url, formData, type) => {
  const options = {
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*",
    },
  };
  return instance
    .put(url, formData, options)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error;
    });
};



